import { render, staticRenderFns } from "./AccionInformacionPago.vue?vue&type=template&id=53ee4ca6&scoped=true&"
import script from "./AccionInformacionPago.vue?vue&type=script&lang=js&"
export * from "./AccionInformacionPago.vue?vue&type=script&lang=js&"
import style0 from "./AccionInformacionPago.vue?vue&type=style&index=0&id=53ee4ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ee4ca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ee4ca6')) {
      api.createRecord('53ee4ca6', component.options)
    } else {
      api.reload('53ee4ca6', component.options)
    }
    module.hot.accept("./AccionInformacionPago.vue?vue&type=template&id=53ee4ca6&scoped=true&", function () {
      api.rerender('53ee4ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/AccionInformacionPago.vue"
export default component.exports